import React, { useState, useEffect } from "react";
import BusServiceFlybus from "./BusServiceFlybus";
import BusServiceAiravatClubClass from "./BusServiceAiravatClubClass";
import BusServiceAiravatBliss from "./BusServiceAiravatBliss";
import BusServicesAiravatSuperia from "./BusServicesAiravatSuperia";
import BusServiceAiravat from "./BusServiceAiravat";
import {
  t,
  HEADING1,
  TAB1,
  TAB2,
  TAB3,
  TAB4,
  TAB5,
} from "../../translations/AboutUs/BusServices";

const BusServicesDetails = (props) => {
  const { busService } = props;

  const [currentBusService, setCurrentBusService] = useState("flybus");

  useEffect(() => {
    setCurrentBusService(busService);
  }, [busService]);

  const handelCurrentTab = () => {
    if (currentBusService == "flybus") {
      return <BusServiceFlybus />;
    }

    if (currentBusService == "airavat-club-class") {
      return <BusServiceAiravatClubClass />;
    }

    if (currentBusService == "airavat-bliss") {
      return <BusServiceAiravatBliss />;
    }

    if (currentBusService == "airavat-superia") {
      return <BusServicesAiravatSuperia />;
    }

    if (currentBusService == "airavat") {
      return <BusServiceAiravat />;
    }
  };
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: "20px",
        paddingRight: "10px",
      }}
    >
      <div style={{ fontSize: "20px", fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <div
        style={{ display: "flex", gap: 3, fontSize: 14 }}
        className="busServiceTabs"
      >
        <div
          style={{
            width: 80,
          }}
          className={`busServiceTab ${
            currentBusService == "flybus" ? "active" : ""
          }`}
          onClick={() => setCurrentBusService("flybus")}
        >
          {t(TAB1)}
        </div>
        <div
          style={{
            width: 150,
          }}
          className={`busServiceTab ${
            currentBusService == "airavat-club-class" ? "active" : ""
          }`}
          onClick={() => setCurrentBusService("airavat-club-class")}
        >
          {t(TAB2)}
        </div>
        <div
          style={{
            width: 110,
          }}
          className={`busServiceTab ${
            currentBusService == "airavat-bliss" ? "active" : ""
          }`}
          onClick={() => setCurrentBusService("airavat-bliss")}
        >
          {t(TAB3)}
        </div>
        <div
          style={{
            width: 125,
          }}
          className={`busServiceTab ${
            currentBusService == "airavat-superia" ? "active" : ""
          }`}
          onClick={() => setCurrentBusService("airavat-superia")}
        >
          {t(TAB4)}
        </div>
        <div
          style={{
            width: 80,
          }}
          className={`busServiceTab ${
            currentBusService == "airavat" ? "active" : ""
          }`}
          onClick={() => setCurrentBusService("airavat")}
        >
          {t(TAB5)}
        </div>
      </div>
      {handelCurrentTab()}
    </div>
  );
};

export default BusServicesDetails;
